var render = function render(){var _vm=this,_c=_vm._self._c;return _c('relationship-with-sun-template',{attrs:{"always-uses-sunscreen":_vm.alwaysUsesSunscreen,"currently-tanned":_vm.currentlyTanned,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }